var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#file_svg__a)",
    stroke: "#69B6AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 28H7a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10l5 5v14a1 1 0 0 1-1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8V5a1 1 0 0 1 1-1h10l5 5v14a1 1 0 0 1-1 1h-3M11 19h6M11 23h6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "file_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgFile;